<script lang="ts" setup>
import Button from 'primevue/button'
import { useRouter } from 'vue-router'

const router = useRouter()

interface EyeProps {
  name: string
  params: Record<string, string | number | null | undefined>
  label?: string
}

const props = defineProps<EyeProps>()
</script>

<template>
  <!-- <div class="flex justify-center items-center"> -->
  <Button as="a" icon="pi pi-eye" size="small" severity="secondary" rounded
    :href="router.resolve({ name: props.name, params: props.params }).fullPath" target="_blank" :label="label">
  </Button>
  <!-- </div> -->
</template>
